"use client";

import React, { useState } from "react";
import "./footer.scss";
import Image from "next/image";
import Link from "next/link";
import { useSelector } from "react-redux";
import { animateScroll as scroll } from "react-scroll";
import { usePathname } from "next/navigation";
import ReactGA from "react-ga4";
import { allRoutes } from "@/data/allRoutes";

import CommingSoonModal from "@/components/modals/commingSoonModal";

import footerLogo from "@/../public/footer/footerLogo.png";
import fb from "@/../public/footer/fb.png";
import sc from "@/../public/footer/sc.png";
import ig from "@/../public/footer/ig.png";
import tw from "@/../public/footer/x.png";
import pi from "@/../public/footer/pi.png";
import yt from "@/../public/footer/yt.png";

export default function Footer() {
  const [showCommingSoonModal, setShowCommingSoonModal] = useState(false);
  const selector = useSelector((data) => data.contactRef);
  const pathname = usePathname();

  const contactUsClickHandler = () => {
    ReactGA.event({
      category: "footer button click",
      action: "button click",
      label: "contact-us", // optional
    });
  };

  const handleContactScroll = () => {
    contactUsClickHandler();
    if (selector.contact) {
      scroll.scrollTo(selector.contact.offsetTop, {
        duration: 500,
        smooth: "easeInOutQuart",
      });
    }
  };

  if (
    pathname === allRoutes.faceSwap ||
    pathname === allRoutes.outputView ||
    pathname === allRoutes.imageGenerator ||
    pathname === allRoutes.headshotGenerator ||
    pathname === "/ai-face-swap-photo-enhancer/durga-maa" ||
    pathname === "/redirect/techkilla-saas-payment-acknowledgement"
  ) {
    return null;
  }

  return (
    <div className="footer">
      {/* left footer */}
      <div className="leftFooter">
        <div className="footerLogo">
          <Image src={footerLogo} alt="logo" />
        </div>
        <div className="leftFooterSecondRow">
          <p className={`txt2`}>
            Instantly switch looks, become anyone with SnapShawt AI! Your go-to
            for easy, fun face swaps in a snap
          </p>
          <ul className="socialIconBox">
            {/* facebook */}
            <Link
              href="https://www.facebook.com/profile.php?id=61557027670734&mibextid=ZbWKwL"
              target="_blank"
            >
              <li>
                <Image src={fb} className="socialIcon" alt="img" />
              </li>
            </Link>

            {/* instagram */}
            <Link
              href="https://www.instagram.com/snapshawt?utm_source=qr&igsh=dGtud3RlNjk5b3gz"
              target="_blank"
            >
              <li>
                <Image src={ig} className="socialIcon" alt="img" />
              </li>
            </Link>

            {/* pinterest */}
            <Link href="https://www.pinterest.com/snapshawt" target="_blank">
              <li>
                <Image src={pi} className="socialIcon" alt="img" />
              </li>
            </Link>
            {/* twitter */}
            <Link
              href="https://x.com/snapshawtai?t=-7uhXGlTjRy-DucKKv5yZQ&s=09"
              target="_blank"
            >
              <li>
                <Image src={tw} className="socialIcon" alt="img" />
              </li>
            </Link>

            {/* Youtube */}
            <Link href="https://www.youtube.com/@Snapshawt_com" target="_blank">
              <li>
                <Image src={yt} className="socialIcon" alt="img" />
              </li>
            </Link>

            {/* snap chat */}
            <Link
              href="https://www.snapchat.com/add/snapshawtai?share_id=j9j1NDafnyg&locale=en-IN"
              target="_blank"
            >
              <li>
                <Image src={sc} className="socialIcon" alt="img" />
              </li>
            </Link>
          </ul>
        </div>
        <div className="flex-col-center leftFooterThirdRow">
          <div className="flex-col-center topContainer">
            <p className="queryTxt">Have any query ?</p>
            <p className="queryTxt">
              Connect with us at:&nbsp;
              <a className="mail" href="mailto:support@snapshawt.com">
                support@snapshawt.com
              </a>
            </p>
          </div>

          <div className={`flex-col-center bottomContainer`}>
            <p className="queryTxt">Mailing Address:</p>

            <p className="queryTxt">
              B-12, Agrasen Plaza, Mahavir Enclave, <br /> New Delhi - 110045
            </p>
          </div>
        </div>
      </div>

      {/* right footer */}
      <div className="rightFooter">
        <ul className="rightFooterColumn f1">
          <Link href={"/"}>
            <li>Home</li>
          </Link>

          <Link href={`${allRoutes.about}`}>
            <li>About</li>
          </Link>

          {pathname !== "/" && pathname !== "/#contact" && (
            <Link href={"/#contact"}>
              <li>Contact us</li>
            </Link>
          )}

          {(pathname === "/" || pathname === "/#contact") && (
            <div onClick={handleContactScroll} style={{ cursor: "pointer" }}>
              <li>Contact us</li>
            </div>
          )}

          <Link href={`${allRoutes.faq.self}`}>
            <li>FAQ</li>
          </Link>

          <Link href={`${allRoutes.refundPolicy}`}>
            <li>Refund Policy</li>
          </Link>

          <Link href={`${allRoutes.privacyPolicy}`}>
            <li>Privacy Policy</li>
          </Link>

          <Link href={`${allRoutes.termsCondition}`}>
            <li>Terms & Conditions</li>
          </Link>
        </ul>
        <ul className="rightFooterColumn f2">
          <Link href={`${allRoutes.faceSwap}`}>
            <li>AI FaceSwap</li>
          </Link>

          <Link href={`${allRoutes.headshotGenerator}`}>
            <li>AI Headshot Generator</li>
          </Link>

          <Link
            href={`${allRoutes.imageEnhancer}`}
            style={{ cursor: "pointer" }}
          >
            <li>AI Image Enhancer</li>
          </Link>

          <Link
            href={`${allRoutes.imageGenerator}`}
            style={{ cursor: "pointer" }}
          >
            <li>AI Image Generator</li>
          </Link>
        </ul>
      </div>

      {/* comming soon modal */}
      {showCommingSoonModal && (
        <CommingSoonModal
          showCommingSoonModal={showCommingSoonModal}
          setShowCommingSoonModal={setShowCommingSoonModal}
        />
      )}
    </div>
  );
}
